/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ReportType } from 'app/shared/model/enumerations/report-type.model';
import { Gender } from 'app/shared/model/enumerations/gender.model';
import { GrowthChartType } from 'app/shared/model/enumerations/growth-chart-type.model';
import { AgeUnit } from 'app/shared/model/enumerations/age-unit.model';

export interface IGrowthLegend {
  id?: string;
  reportType?: keyof typeof ReportType | null;
  gender?: keyof typeof Gender | null;
  chartType?: keyof typeof GrowthChartType | null;
  ageFrom?: number | null;
  ageTo?: number | null;
  ageUnit?: keyof typeof AgeUnit | null;
  lambda?: number | null;
  mean?: number | null;
  sigma?: number | null;
  delta?: number | null;
  p01?: number | null;
  p1?: number | null;
  p3?: number | null;
  p5?: number | null;
  p10?: number | null;
  p15?: number | null;
  p25?: number | null;
  p50?: number | null;
  p75?: number | null;
  p85?: number | null;
  p90?: number | null;
  p95?: number | null;
  p97?: number | null;
  p99?: number | null;
  p999?: number | null;
  SD4neg?: number | null;
  SD3neg?: number | null;
  SD2neg?: number | null;
  SD1neg?: number | null;
  SD0?: number | null;
  SD1?: number | null;
  SD2?: number | null;
  SD3?: number | null;
  SD4?: number | null;
  active?: boolean;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  cursor?: number;
  publishedYear?: number | null;
}

export const defaultValue: Readonly<IGrowthLegend> = {
  active: false,
};
